import { render } from "./Upload.vue?vue&type=template&id=28e08de2&ts=true"
import script from "./Upload.ts?vue&type=script&lang=ts&external"
export * from "./Upload.ts?vue&type=script&lang=ts&external"

import "./Upload.scss?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__